import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FaShoppingCart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CartDrawer from "./CartDrawer";

const Header = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-transparent flex justify-between items-center p-4 fixed top-0 left-0 w-full z-50 shadow-none">
      <div className="flex items-center space-x-2">
        <button
          className="px-4 py-2 border border-white rounded-full text-white"
          onClick={() => navigateTo('/')}
        >
          shop
        </button>
        <button
          className="px-4 py-2 border border-white rounded-full text-white"
          onClick={() => navigateTo('/drop')}
        >
          drop
        </button>
      </div>
      <div className="flex items-center space-x-2">
        <button
          className="px-4 py-2 border border-white rounded-full text-white"
          onClick={() => navigateTo('/cuidados')}
        >
          info
        </button>
        <button
          onClick={toggleCart}
          className="px-4 py-2 border border-white rounded-full text-white relative"
        >
          <FaShoppingCart size={18} />
          {cart.length > 0 && (
            <span className="absolute top-0 right-0 transform -translate-y-1/2 translate-x-1/2 bg-red-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
              {cart.length}
            </span>
          )}
        </button>
      </div>
      {isCartOpen && <CartDrawer onClose={toggleCart} />}
    </div>
  );
};

export default Header;
